var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import get from "lodash/get";
import omit from "lodash/omit";
import assign from "lodash/assign";
import entries from "lodash/entries";
import flowRight from "lodash/flowRight";
import debounce from "lodash/debounce";
import axios from "axios";
import querystring from 'querystring';
import { reportError } from './lib/reportErrors';
import omitBy from "lodash/omitBy";
import { Cookies, getAccessToken, getAdminAccessToken, getAdminRefreshToken, getRefreshToken, setAccessToken, setRefreshToken } from "./cookies";
import { getResponseManager } from "./responseManager/BeeResponseManager";
export var defaultAdminIntegrationName = "vb-backend-integration";
export var defaultIntegrationName = "singleintegration";
var debouncedReportError = debounce(reportError, 100, { leading: true });
var wsApiInstance = new Map();
export var createAxiosInstance = function (baseURLObject, _a) {
    var _b = _a.proxyUrl, proxyUrl = _b === void 0 ? "" : _b, _c = _a.urlEncodePath, urlEncodePath = _c === void 0 ? false : _c, _d = _a.axiosInstance, axiosInstance = _d === void 0 ? axios : _d, _e = _a.apiPath, apiPath = _e === void 0 ? "/api" : _e;
    entries(baseURLObject).forEach(function (_a) {
        var name = _a[0], baseURL = _a[1];
        if (wsApiInstance.get(name))
            return;
        wsApiInstance.set(name, apiFactory(axiosInstance, { name: name, baseURL: new URL(apiPath, baseURL).href, urlEncodePath: urlEncodePath, proxyUrl: proxyUrl }));
    });
};
function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
}
var apiFactory = function (axiosInstance, options) {
    var WsAPI = /** @class */ (function () {
        function WsAPI(options) {
            this.name = "";
            this.baseURL = "";
            this.proxyUrl = "";
            this.urlEncodePath = false;
            assign(this, options);
            this.axiosInstance = axiosInstance;
        }
        Object.defineProperty(WsAPI.prototype, "isAdminIntegration", {
            get: function () {
                return this.name === defaultAdminIntegrationName;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WsAPI.prototype, "accessToken", {
            get: function () {
                return this.isAdminIntegration ? getAdminAccessToken() : getAccessToken(this.name);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WsAPI.prototype, "refreshToken", {
            get: function () {
                return this.isAdminIntegration ? getAdminRefreshToken() : getRefreshToken(this.name);
            },
            enumerable: false,
            configurable: true
        });
        WsAPI.prototype.useProxyUrl = function (url) {
            if (!this.proxyUrl)
                return url;
            return new URL("?url=" + url, this.proxyUrl).href;
        };
        WsAPI.prototype.useEncodedURL = function (url) {
            if (!this.urlEncodePath)
                return url;
            url = url.startsWith("http") ? url : new URL(url, this.baseURL).href;
            return encodeURIComponent(url);
        };
        WsAPI.prototype.getUrl = function (url) {
            return flowRight(this.useProxyUrl.bind(this), this.useEncodedURL.bind(this), xDebugUrl)(url);
        };
        WsAPI.prototype.withCancelToken = function (options) {
            if (options === void 0) { options = {}; }
            var cancelToken = get(options, "cancelToken.set");
            return __assign(__assign({}, options), { cancelToken: cancelToken && new axios.CancelToken(cancelToken) });
        };
        WsAPI.prototype.ensureRefreshToken = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.accessToken)
                                return [2 /*return*/];
                            if (!this.refreshToken)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.refreshUserToken(undefined)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        WsAPI.prototype.fetch = function (url, params, _a) {
            if (params === void 0) { params = {}; }
            if (_a === void 0) { _a = {}; }
            var _b = _a.cache, cache = _b === void 0 ? false : _b, _c = _a.auth, auth = _c === void 0 ? false : _c, options = __rest(_a, ["cache", "auth"]);
            return __awaiter(this, void 0, void 0, function () {
                var key, authHeader, headers, resultPromise, promiseToComplete;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            key = new URL(this.getUrl(url), this.baseURL).href;
                            if (cache && WsAPI.apiCache.has(key)) {
                                return [2 /*return*/, WsAPI.apiCache.get(key)];
                            }
                            if (!(auth || this.isAdminIntegration)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.ensureRefreshToken()];
                        case 1:
                            _d.sent();
                            _d.label = 2;
                        case 2:
                            authHeader = (auth ? { Authorization: "Bearer " + this.accessToken } : undefined);
                            headers = options.headers ? __assign(__assign({}, options.headers), authHeader) : authHeader;
                            resultPromise = this.axiosInstance.get(this.getUrl(url), __assign(__assign({}, options), { headers: headers, baseURL: this.baseURL, params: params }));
                            promiseToComplete = this.processResponseOrThrow(resultPromise, options);
                            if (!cache) {
                                return [2 /*return*/, promiseToComplete];
                            }
                            WsAPI.apiCache.set(key, promiseToComplete);
                            return [2 /*return*/, WsAPI.apiCache.get(key)];
                    }
                });
            });
        };
        WsAPI.prototype.post = function (url, requestData, _a) {
            if (_a === void 0) { _a = {}; }
            var cache = _a.cache, options = __rest(_a, ["cache"]);
            return __awaiter(this, void 0, void 0, function () {
                var resultPromise;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(options.auth || this.isAdminIntegration)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.ensureRefreshToken()];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            resultPromise = this.axiosInstance.post(this.getUrl(url), requestData, __assign(__assign({}, options), { baseURL: this.baseURL }));
                            return [2 /*return*/, this.processResponseOrThrow(resultPromise, __assign(__assign({}, options), { clearNotifications: true }))];
                    }
                });
            });
        };
        WsAPI.prototype.getInitialData = function (cancelToken) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/initdata', {}, this.withCancelToken({ cache: true, cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getBookEntities = function (cancelToken, queryString) {
            if (queryString === void 0) { queryString = ''; }
            return __awaiter(this, void 0, void 0, function () {
                var _a, include, query, explodeString, excludes;
                return __generator(this, function (_b) {
                    _a = querystring.parse(queryString), include = _a.include, query = __rest(_a, ["include"]);
                    explodeString = function (queryPart) {
                        return decodeURIComponent([].concat((queryPart !== null && queryPart !== void 0 ? queryPart : "")).join(",")).split(",").map(function (x) { return x.trim(); }).filter(Boolean);
                    };
                    excludes = new Set(["trainer", "appointments"].concat(explodeString(query.exclude)));
                    // remove all inclusions from exclusions
                    explodeString(include)
                        .forEach(function (inclusion) { excludes.delete(inclusion); });
                    // it already forwards all query params so no need to add xdebug flags
                    return [2 /*return*/, this.fetch('/book?' + decodeURIComponent(querystring.stringify(__assign(__assign({}, query), { exclude: excludes.size ? Array.from(excludes).filter(Boolean).join(",") : undefined }))), {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getCustomerUsersEntites = function (cancelToken, params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/customers', params, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getCustomerList = function (cancelToken, params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/customerlist', params, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.postBookForm = function (cancelToken, requestData) {
            return __awaiter(this, void 0, void 0, function () {
                var toWaitList, rest, path;
                return __generator(this, function (_a) {
                    toWaitList = requestData.toWaitList, rest = __rest(requestData, ["toWaitList"]);
                    path = toWaitList ? "/waitlist" : 'book';
                    return [2 /*return*/, this.post(path, rest, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getPaymentEntities = function (cancelToken, _a) {
            var sessionId = _a.sessionId, couponCode = _a.couponCode, couponCodeRemoved = _a.couponCodeRemoved;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.fetch('/paybook', omitBy({
                            remove_coupon: couponCodeRemoved,
                            payment_session_id: sessionId,
                            coupon_code: couponCode,
                        }, function (x) { return x === undefined; }), this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.postPaymentForm = function (cancelToken, requestData) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.post('/paybook', requestData, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getPaymentApproved = function (cancelToken, queryObject) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/paybook/approved?' + querystring.stringify(queryObject), {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getPaymentCancelled = function (cancelToken, queryObject) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/paybook/cancelled?' + querystring.stringify(queryObject), {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getBankTransferEntities = function (cancelToken, queryObject) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/banktransfer?' + querystring.stringify(queryObject), {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getUserConsentsEntities = function (cancelToken, token) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/user/consents?token=' + token, {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.postUserConsentsForm = function (cancelToken, token, form) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.post('/user/consents?token=' + token, form, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getSepaDirectDebitEntities = function (cancelToken, payment_session_id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/sepadirectdebit?payment_session_id=' + payment_session_id, {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.postSepaDirectDebitForm = function (cancelToken, payment_session_id, form) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.post('/sepadirectdebit?payment_session_id=' + payment_session_id, form, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getWaitlistEntities = function (cancelToken) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch('/waitlist', {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.reportException = function (cancelToken, _a) {
            var store = _a.store, error = _a.error;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    // if (process.env.NODE_ENV !== "production") return Promise.resolve({});
                    debouncedReportError(error, omit(store, "responseReducer"));
                    // return this.post('/reportexception', {
                    //     store,
                    //     title: error.name,
                    //     message: error.message,
                    //     stack: error.stack,
                    //     userAgent: navigator.userAgent,
                    //     url: window.location.href,
                    //     version
                    // }, this.withCancelToken({ cancelToken }));
                    return [2 /*return*/, {
                            data: undefined,
                            clearNotifications: false
                        }];
                });
            });
        };
        WsAPI.prototype.getOutgoingMessages = function (cancelToken, queryString) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch("/user/outgoingmessages?" + queryString, {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getSuccessMessages = function (cancelToken, queryString) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch("/success?" + queryString, {}, this.withCancelToken({ cancelToken: cancelToken }))];
                });
            });
        };
        WsAPI.prototype.getCancelBookingEntities = function (cancelToken, params) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.fetch("/confirmcancelbooking", params)];
                });
            });
        };
        WsAPI.prototype.postCancelBookingForm = function (cancelToken, requestData) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.post("/confirmcancelbooking", requestData)];
                });
            });
        };
        WsAPI.prototype.postSuccessAction = function (cancelToken, requestData) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.post("/customaction", requestData)];
                });
            });
        };
        WsAPI.prototype.getCmsContent = function (cancelToken, _a) {
            var model_name = _a.model_name, model_id = _a.model_id;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, this.fetch("/" + model_name + "/" + model_id)];
                });
            });
        };
        WsAPI.prototype.getDownloadConsentURL = function (hash) {
            return new URL(this.getUrl("admin/downloadcensentform?token=" + hash), this.baseURL).href;
        };
        WsAPI.prototype.fetchUserEntity = function (cancelToken, _a) {
            var entity = _a.entity;
            return this.fetch("/customer/" + entity, undefined, this.withCancelToken({ cancelToken: cancelToken, auth: true, }));
        };
        WsAPI.prototype.fetchUser = function (cancelToken) {
            return this.fetch("/customer", undefined, this.withCancelToken({ cancelToken: cancelToken, auth: true, }));
        };
        WsAPI.prototype.requestAuthenticationLink = function (cancelToken, _a) {
            var email = _a.email;
            return this.post("/customer/requestloginlink", { email: email }, this.withCancelToken({ cancelToken: cancelToken }));
        };
        WsAPI.prototype.refreshUserToken = function (cancelToken) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var x, result, accessToken;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.isAdminIntegration) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.axiosInstance.get("/admin/refreshToken", {
                                    headers: { bearer: Cookies.get("refreshToken") },
                                })];
                        case 1:
                            x = _b.sent();
                            return [2 /*return*/];
                        case 2: return [4 /*yield*/, this.post("/customer/refreshtoken", {}, {
                                headers: {
                                    Authorization: "Bearer " + this.refreshToken
                                }
                            })];
                        case 3:
                            result = _b.sent();
                            switch (result.data.name) {
                                case "refresh_token":
                                    accessToken = (_a = getResponseManager(result.data).getRefreshResponse()) === null || _a === void 0 ? void 0 : _a.authToken;
                                    setAccessToken(this.name, accessToken);
                                    return [2 /*return*/, result];
                                default:
                                    setAccessToken(this.name, { token: '' });
                                    setRefreshToken(this.name, { token: '' });
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        };
        WsAPI.prototype.authenticateUser = function (cancelToken, _a) {
            var loginToken = _a.loginToken;
            return __awaiter(this, void 0, void 0, function () {
                var result, _b, authToken, refreshToken;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.post("/customer/authenticate", { loginToken: loginToken }, this.withCancelToken({ cancelToken: cancelToken }))];
                        case 1:
                            result = _c.sent();
                            switch (result.data.name) {
                                case "auth_token": {
                                    _b = getResponseManager(result.data).getAuthResponse(), authToken = _b.authToken, refreshToken = _b.refreshToken;
                                    setAccessToken(this.name, authToken);
                                    setRefreshToken(this.name, refreshToken);
                                    return [2 /*return*/, result];
                                }
                                default: {
                                    setAccessToken(this.name, { token: '' });
                                    setRefreshToken(this.name, { token: '' });
                                }
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        };
        WsAPI.prototype.logout = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post("/customer/logout", { auth: true })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        WsAPI.prototype.processResponseOrThrow = function (dataRequest, _a) {
            var _b = _a.clearNotifications, clearNotifications = _b === void 0 ? false : _b;
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, dataRequest];
                        case 1:
                            result = _c.sent();
                            if (result.status) {
                                return [2 /*return*/, {
                                        data: result.data,
                                        clearNotifications: clearNotifications
                                    }];
                            }
                            throw result;
                    }
                });
            });
        };
        ;
        WsAPI.apiCache = new Map;
        return WsAPI;
    }());
    return new WsAPI(options);
};
// super hacky function to always forward the XDEBUG_SESSION_START parameter on requests for easier backend debugging
var xDebugUrl = function (url) {
    try {
        var xdebugMatch = window.location.href.match(/XDEBUG_SESSION_START=\d+/i);
        var xdebugStr = '';
        if (xdebugMatch) {
            xdebugStr = xdebugMatch[0];
            setCookie('xdebug_str', xdebugStr, 1);
        }
        else {
            var cookieVal = getCookie('xdebug_str');
            xdebugStr = cookieVal ? cookieVal : '';
        }
        if (!xdebugStr.length) {
            return url;
        }
        var hasParams = url.indexOf('?') > -1;
        return hasParams ? url + "&" + xdebugStr : url + "?" + xdebugStr;
    }
    catch (e) {
        // make errors not worse :)
        console.error(e);
        return url;
    }
};
export var API_METHODS_ENUM;
(function (API_METHODS_ENUM) {
    API_METHODS_ENUM["GET_INITIAL_ENTITIES"] = "getInitialData";
    API_METHODS_ENUM["GET_BOOK_ENTITIES"] = "getBookEntities";
    API_METHODS_ENUM["GET_CUSTOMER_ENTITIES"] = "getCustomerUsersEntites";
    API_METHODS_ENUM["GET_CUSTOMER_LIST"] = "getCustomerList";
    API_METHODS_ENUM["POST_BOOKING_FORM"] = "postBookForm";
    API_METHODS_ENUM["GET_PAYBOOK_ENTITIES"] = "getPaymentEntities";
    API_METHODS_ENUM["POST_PAYBOOK_FORM"] = "postPaymentForm";
    API_METHODS_ENUM["GET_PAYMENT_APPROVED"] = "getPaymentApproved";
    API_METHODS_ENUM["GET_PAYMENT_CANCELLED"] = "getPaymentCancelled";
    API_METHODS_ENUM["GET_BANK_TRANSFER_ENTITIES"] = "getBankTransferEntities";
    API_METHODS_ENUM["GET_USER_CONSENTS"] = "getUserConsentsEntities";
    API_METHODS_ENUM["GET_WAITLIST_ENTITIES"] = "getWaitlistEntities";
    API_METHODS_ENUM["POST_USER_CONSENTS"] = "postUserConsentsForm";
    API_METHODS_ENUM["GET_SEPA_ENTITIES"] = "getSepaDirectDebitEntities";
    API_METHODS_ENUM["POST_SEPA_FORM"] = "postSepaDirectDebitForm";
    API_METHODS_ENUM["REPORT_EXCEPTION"] = "reportException";
    API_METHODS_ENUM["GET_OUTGOING_MESSAGES"] = "getOutgoingMessages";
    API_METHODS_ENUM["GET_SUCCESS_MESSAGES"] = "getSuccessMessages";
    // GET_CERTIFICATE_LIST_ENTITIES = "getCertificateListEntities",
    API_METHODS_ENUM["GET_CANCEL_BOOKING_ENTITIES"] = "getCancelBookingEntities";
    API_METHODS_ENUM["POST_CANCEL_BOOKING_FORM"] = "postCancelBookingForm";
    API_METHODS_ENUM["POST_SUCCESS_ACTION"] = "postSuccessAction";
    API_METHODS_ENUM["CMS"] = "getCmsContent";
    API_METHODS_ENUM["FETCH_USER"] = "fetchUser";
    API_METHODS_ENUM["FETCH_USER_ENTITY"] = "fetchUserEntity";
    API_METHODS_ENUM["REFRESH_USER_TOKEN"] = "refreshUserToken";
    API_METHODS_ENUM["REQUEST_AUTHENTICATION_LINK"] = "requestAuthenticationLink";
    API_METHODS_ENUM["AUTHENTICATE_USER"] = "authenticateUser";
    API_METHODS_ENUM["LOGOUT"] = "logout";
})(API_METHODS_ENUM || (API_METHODS_ENUM = {}));
var defaultInstance = apiFactory(axios, {});
export var getAxiosInstance = function (name) {
    var instance = wsApiInstance.get(name);
    if (!instance) {
        console.error("Configuration Error: Base url " + name + " is not configured");
        return defaultInstance;
    }
    return instance;
};
export var getAPI = function (name, methodName, cancelToken) {
    var instance = getAxiosInstance(name);
    return instance[methodName].bind(instance, cancelToken);
};
